import { render, staticRenderFns } from "./Fgts.vue?vue&type=template&id=623c41ae"
import script from "./Fgts.vue?vue&type=script&lang=js"
export * from "./Fgts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports